import { useCachedApiCall } from '@hooks/apiCall';
import type { UseCachedApiCallResult } from '@hooks/apiCall';
import type {
    ShiftGeneratorTask,
    ShiftGeneratorTaskParams,
} from '@api/ShiftGeneratorTaskService';
import {
    shiftGeneratorTaskCache,
    shiftGeneratorTasksCache,
} from './shiftGeneratorTaskStore';

/*
 * Thin cache-backed bindings so hooks and features don't hand-roll
 * param arrays. See docs/api-caching.md §8 for the hook contract.
 */

/** Cache-backed shift generator task detail. */
export const useShiftGeneratorTaskEntry = (
    departmentId?: string,
    taskId?: string,
    params?: ShiftGeneratorTaskParams,
): UseCachedApiCallResult<ShiftGeneratorTask> =>
    useCachedApiCall(
        shiftGeneratorTaskCache,
        [departmentId, taskId, params],
        [departmentId, taskId],
    );

/** Cache-backed shift generator task list of a department. */
export const useShiftGeneratorTasksEntry = (
    departmentId?: string,
): UseCachedApiCallResult<ShiftGeneratorTask[]> =>
    useCachedApiCall(shiftGeneratorTasksCache, [departmentId], [departmentId]);
